<template lang="pug">
redesign-dialog(
  v-model="showDialog"
  width="1240"
  @close="showDialog = false"
)
  template(#default)
    .list-dialog
      .list-dialog__heading
        div.d-flex
          v-icon.mr-6(
            v-if="icon"
            size="28"
            color="redesignPrimary"
          ) {{ icon }}
          strong.flex-1 {{ title }}
          v-btn.ml-auto(icon small @click="showDialog = false")
            v-icon(color="redesignBlack") $iclose
        v-sheet.overflow-y-auto.redesign-scrollbar(
          max-height="250px"
        )
          p(v-html="caption")
      app-tabs-group.my-4(
        v-model="selectedFilter"
        :items="tabs"
      )
      data-list.list-dialog__data(
        :key="selectedFilter"
        :method="preparedMethod"
        :serializeData="serializeData"
      )
        template(#item--content="{ item }")
          slot(name="item--content" :item="item")
      slot(name="additional-content")
</template>

<script>
import RedesignDialog from './RedesignDialog.vue';
import AppTabsGroup from '../controls/AppTabsGroup.vue';
import DataList from '../DataList.vue';

export default {
  name: 'RedesignListDialog',
  components: {
    RedesignDialog,
    AppTabsGroup,
    DataList,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    method: {
      type: Function,
      required: true,
    },
    serializeData: {
      type: Function,
      default: (data) => data,
    },
  },
  data() {
    return {
      selectedFilter: this.tabs[0]?.value || null,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
  watch: {
    selectedFilter: {
      handler(value) {
        this.$emit('update:selected-tab', value);
      },
      immediate: true,
    },
    value(value) {
      if (value) {
        return;
      }

      this.selectedFilter = this.tabs[0]?.value || null;
    },
  },
  methods: {
    preparedMethod(params) {
      const paramsResult = {
        ...params,
      };
      const filter = this.tabs.find(({ value }) => this.selectedFilter === value);
      if (filter && filter.filters) {
        const keys = Object.keys(filter.filters);
        keys.forEach((k) => {
          paramsResult[k] = filter.filters[k];
        });
      }
      return this.method(paramsResult);
    },
  },
};
</script>

<style scoped lang="scss">
.list-dialog {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;

  &__footer {
    margin-top: auto;
    text-align: center;
  }

  &__heading {
    display: flex;
    flex-direction: column;
    gap: 8px;
    & * strong {
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
    }

    & > p {
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      color: #{$redesignSecondary};
    }
  }

  &__data {
    min-height: 435px;
  }
}
</style>
